module.exports = __webpack_public_path__ + "img/mobile scanner stand44.75fd95bb.jpg";